import MedicalIcon from "./MedicalIcons";
import "./MedicalHero3D.css";

export default function MedicalHero3D() {
  return (
    <div className="hi-hero-3d" aria-hidden="true">
      <div className="hi-hero-3d__stage">
        <div className="hi-hero-3d__orb hi-hero-3d__orb--1" />
        <div className="hi-hero-3d__orb hi-hero-3d__orb--2" />

        <div className="hi-hero-3d__silhouette">
          <div className="hi-hero-3d__body" />
          <div className="hi-hero-3d__head" />
        </div>

        <div className="hi-hero-3d__float hi-hero-3d__float--heart">
          <MedicalIcon name="heart" size={18} className="hi-hero-3d__svg" />
          <span className="hi-hero-3d__label">심장 건강</span>
        </div>

        <div className="hi-hero-3d__float hi-hero-3d__float--lung">
          <MedicalIcon name="wind" size={18} className="hi-hero-3d__svg" />
          <span className="hi-hero-3d__label">호흡기</span>
        </div>

        <div className="hi-hero-3d__float hi-hero-3d__float--checkup">
          <MedicalIcon name="clipboardCheck" size={18} className="hi-hero-3d__svg" />
          <span className="hi-hero-3d__label">건강검진</span>
          <span className="hi-hero-3d__sub">Premium</span>
        </div>

        <div className="hi-hero-3d__ring" />
      </div>
    </div>
  );
}
